import { Helmet } from "react-helmet-async";

export const SITE = "https://workwithlottie.com";
const DEFAULT_IMG = `${SITE}/lottie-og.png`;
export const DEFAULT_DESC =
  "Lottie is your intelligent month-end assistant for Xero — automate accruals, prepayments and deferred income, post the journals and keep live registers. Free 7-day trial.";
const DEFAULT_TITLE = "WorkWithLottie | Accruals, Prepayments & Deferred Income for Xero";

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "WorkWithLottie",
  url: SITE,
  logo: `${SITE}/lottie-logo.png`,
  email: "hello@workwithlottie.com",
  description: DEFAULT_DESC,
};

export const SOFTWARE_JSONLD = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "WorkWithLottie",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  url: SITE,
  description: DEFAULT_DESC,
  offers: {
    "@type": "Offer",
    price: "39",
    priceCurrency: "GBP",
    description: "Per connected Xero organisation, per month. 7-day free trial.",
  },
};

export default function Seo({
  title,
  description = DEFAULT_DESC,
  path = "/",
  image = DEFAULT_IMG,
  type = "website",
  jsonLd,
  publishedTime,
  modifiedTime,
}) {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} | WorkWithLottie` : DEFAULT_TITLE;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="WorkWithLottie" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {type === "article" && publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {type === "article" && modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {type === "article" && <meta property="article:publisher" content={SITE} />}

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
